import { FilteredItem } from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { GetChargingSessionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/charging-sessions/get-charging-sessions-paginated.model';

import {
  EMSP_BO_CHARGING_SESSION_LIST_FILTER,
  EMSP_BO_CHARGING_SESSION_LIST_FILTER_NAME_LIST,
} from '../emsp-bo-charging-session-list/emsp-bo-charging-session-list.config';
import { useEmspBoChargingSessionListContext } from '../emsp-bo-charging-session.context';
import * as css from './emsp-bo-charging-session-list-filter-state.module.scss';

export const EmspBoChargingSessionListFilterStateController =
  (): React.JSX.Element => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
      useEmspBoChargingSessionListContext();

    // HANDLERS //////////////////////////////////////////////////////////////////

    const handleRemove = <
      FilterNameKey extends keyof GetChargingSessionsPaginatedModel,
    >(
      filterName: FilterNameKey,
      filterValue: GetChargingSessionsPaginatedModel[FilterNameKey],
    ): void => {
      setGetPaginatedQueryParameters((current) => {
        const queryParameterValue = current[filterName];

        if (Array.isArray(queryParameterValue) && !Array.isArray(filterValue)) {
          return {
            ...current,
            [filterName]: queryParameterValue.filter(
              (queryParameterValueItem) =>
                queryParameterValueItem !== filterValue,
            ),
          };
        }

        return {
          ...current,
          [filterName]: undefined,
        };
      });
    };

    // DATA FETCHING /////////////////////////////////////////////////////////////

    const filterNameActiveList =
      EMSP_BO_CHARGING_SESSION_LIST_FILTER_NAME_LIST.filter(
        (filterName) => getPaginatedQueryParameters[filterName] !== undefined,
      );

    // RENDER ////////////////////////////////////////////////////////////////////

    return (
      <Stack
        className={css.filtersSection}
        flex={1}
        gap={GapEnum.S}
        justifyContent="space-between"
        alignItems="center">
        <Stack
          direction="row"
          className={css.displayedFiltersSection}
          gap={GapEnum.S}
          alignItems="center"
          flex={1}>
          {filterNameActiveList
            .flatMap((filterName) => {
              const filterValue = getPaginatedQueryParameters[filterName];

              if (filterValue === undefined) {
                return [];
              }

              const FilteredItemComponent =
                EMSP_BO_CHARGING_SESSION_LIST_FILTER[filterName]?.componentType;

              // Case 1: Query parameter is a set of values
              if (Array.isArray(filterValue)) {
                return filterValue.map((filterValueItem) => {
                  if (FilteredItemComponent) {
                    return (
                      <FilteredItemComponent
                        key={`${filterName}-${filterValueItem}`}
                        value={filterValueItem}
                        onRemove={() =>
                          handleRemove(filterName, filterValueItem)
                        }
                      />
                    );
                  }

                  return [
                    <FilteredItem
                      key={`${filterName}-${filterValueItem}`}
                      label={`${filterValueItem}`}
                      onRemove={() => handleRemove(filterName, filterValueItem)}
                    />,
                  ];
                });
              }

              // Case 2: Query parameter is a unique value
              if (FilteredItemComponent) {
                return [
                  <FilteredItemComponent
                    key={filterName}
                    value={filterValue}
                    onRemove={() => handleRemove(filterName, filterValue)}
                  />,
                ];
              }

              return [
                <FilteredItem
                  key={filterName}
                  label={`${filterValue}`}
                  onRemove={() => handleRemove(filterName, filterValue)}
                />,
              ];
            })
            .slice(0, 3)}
        </Stack>
      </Stack>
    );
  };
